const InboxError = ({ errorMessage }) => (
  <div className='inbox_details_wrapper'>
    <div className='inbox_details_item' dangerouslySetInnerHTML={{ __html: errorMessage }} />
  </div>
)
// Export the component for use.
export default InboxError
